import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { getTextFlowChains } from 'editor/src/store/design/util/textFlow';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

/**
 * Takes the chain of the given text apart. Each frame keeps the text it shows, so
 * nothing moves on the canvas; the frames just stop passing text on.
 */
const unlinkTextFramesOperation = (uuid: number) => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const chain = getTextFlowChains(getState().design.designData).find((members) =>
    members.some(({ element }) => element.uuid === uuid),
  );
  if (!chain) {
    return;
  }
  batch(() => {
    dispatch(saveUndoRedoStateOperation('Text frames unlinked'));
    chain.forEach(({ element, address }) => {
      const { textFlow, ...extra } = element.extra;
      dispatch(updateMediaElementAction({ elementAddress: address, elementUpdate: { extra } }));
    });
  });
};

export default unlinkTextFramesOperation;
